import React from 'react';
import { ScrollView, View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Separator } from 'src/components/Separator';
import { Card } from 'src/components/Card';
import { Interpose } from 'src/components/Interpose';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { CardScroll } from 'src/components/CardScroll/CardScroll';
import { Group } from 'src/components/Group';
import { GroupHeader } from 'src/components/GroupHeader';

storiesOf('CardScroll', module).add('Default', () => (
  <ScrollView>
    <PanelHeader>📜 CardScroll</PanelHeader>
    <PlatformPadding horizontal>
      <Group header={<GroupHeader>Within Group 👀</GroupHeader>} separator={false}>
        <CardScroll size="s">
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
          <Card variant="simple" style={{ backgroundColor: '#ececec', height: 100 }} />
        </CardScroll>
      </Group>
    </PlatformPadding>
    <Separator size="l" />
    <GroupHeader>Outside of other components</GroupHeader>
    <Interpose separator={<Separator size="s" />}>
      <CardScroll size="m" padding>
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
      </CardScroll>
      <CardScroll size="l" padding>
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
        <Card variant="simple" style={{ backgroundColor: '#ececec', height: 200 }} />
      </CardScroll>
    </Interpose>
    <Separator size="l" />
    <GroupHeader>Custom width</GroupHeader>
    <CardScroll size={64} padding>
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
      <Card variant="simple" style={{ backgroundColor: '#ececec', height: 64 }} />
    </CardScroll>
  </ScrollView>
));
